import React from "react";

const TYPE_STYLES = {
  success: { background: "#FFFFFF", border: "#E2E2E2", color: "#208a3e" },
  warning: { background: "#FFF5FB", border: "#F9009133", color: "#151515" },
  error:   { background: "#FFFFFF", border: "#fca5a5", color: "#e53935" },
};

export function Toast({ message, type = "success" }) {
  if (!message) return null;
  const { background, border, color } = TYPE_STYLES[type] ?? TYPE_STYLES.success;
  return (
    <div
      role={type === "error" ? "alert" : "status"}
      aria-live={type === "error" ? "assertive" : "polite"}
      aria-atomic="true"
      style={{
        position:"fixed", bottom:28, left:"50%", transform:"translateX(-50%)",
        background, border:`1px solid ${border}`,
        borderRadius:10, padding:"12px 20px", zIndex:1100, maxWidth:420, textAlign:"center",
        color, fontSize:13, fontWeight:500,
        boxShadow:"0 4px 24px rgba(0,0,0,0.12)",
      }}>
      {message}
    </div>
  );
}

// Returns [toast, showToast] — call showToast(message, type) to display, auto-dismisses after durationMs.
export function useToast(durationMs = 6000) {
  const [toast, setToast] = React.useState(null);
  const timerRef = React.useRef(null);
  const showToast = React.useCallback((message, type = "success") => {
    clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), durationMs);
  }, [durationMs]);
  React.useEffect(() => () => clearTimeout(timerRef.current), []);
  return [toast, showToast];
}
